package com.havn.app.core.supabase

object HavnSupabaseConfig {
    val url = havnSupabaseUrl
    val anonKey = havnSupabasePublishableKey
    val environment = havnEnvironmentName
    const val propertyPhotosBucket = "property-photos"
}

expect val havnEnvironmentName: String
expect val havnSupabaseUrl: String
expect val havnSupabasePublishableKey: String
expect val havnMapKitJsToken: String
expect val havnAuthRedirectScheme: String
expect val havnAuthRedirectHost: String
